// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @ constants
const {
    MORTGAGE_REQUEST_FETCH_ACTIVITIES_REQUEST,
    MORTGAGE_REQUEST_FETCH_ACTIVITIES_SUCCESS,
    MORTGAGE_REQUEST_FETCH_ACTIVITIES_FAILURE
} = require('constants/actionTypes');

const requestActivitiesInProgress = () => ({ type: MORTGAGE_REQUEST_FETCH_ACTIVITIES_REQUEST });

const requestActivitiesSuccess = data => {
    return {
        type: MORTGAGE_REQUEST_FETCH_ACTIVITIES_SUCCESS,
        data: data
    };
};

const requestActivitiesFailure = error => ({
    type: MORTGAGE_REQUEST_FETCH_ACTIVITIES_FAILURE,
    data: {
        error
    }
});

const getMortgageActivities = language => dispatch => {
    dispatch(requestActivitiesInProgress());
    const params = {
        query: {
            language
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('mortgageRequestActivities'), params)
        .then(response => dispatch(requestActivitiesSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestActivitiesFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getMortgageActivities
};
